<div
	#NodeContainer
	id="node-container"
>
	@if (nodes?.length) {
		@for (node of nodes; track node) {
			<ng-container *ngTemplateOutlet="NodeTemplate; context: { node: node }" />
		}
	} @else {
		<div class="node-item">
			<div class="ada-container ada-col-0">
				<div
					style="width: 1rem"
					[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
				></div>
				<span
					class="logical-icon"
					[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
				>
					<ada-icon
						color="foreground"
						icon="faClipboardList"
						[isDisabled]="isDisabled"
					/>
				</span>
				<ada-text
					content="Select Operator or Expression"
					fontWeight="bold"
					[horizontalGrowEnabled]="true"
					[isDisabled]="isDisabled"
				/>
				<ada-icon
					ada-type="base"
					color="primary"
					horizontalAlignment="right"
					icon="faEllipsisH"
					style="cursor: pointer"
					tooltip="Rule Options"
					[adaMenuTrigger]="MainMenu"
					[isDisabled]="isDisabled"
					[ngStyle]="{ height: UI.Spacing.SPACING_LARGE }"
				/>
			</div>
		</div>
	}
</div>

<ng-template
	#NodeTemplate
	let-node="node"
>
	<div
		class="node-item"
		[attr.data-id]="node.id"
		[attr.id]="'node-' + node.id"
	>
		<div class="ada-container ada-col-0 ada-flex-align-start">
			@if (node.children?.length) {
				<button
					[class.is-open]="node.isExpanded"
					[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
					(click)="node.toggle()"
				>
					<ada-icon
						[color]="'foreground'"
						[icon]="'faAngleRightOutline'"
					/>
				</button>
			} @else {
				<div
					style="width: 1rem"
					[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
				></div>
			}
			<span
				class="logical-icon"
				[ngStyle]="{ 'margin-right': UI.Spacing.SPACING_SMALL }"
			>
				@if (node.type | isParentType) {
					<span [ngClass]="[node.children?.length ? 'expandable' : 'flat']">
						{{ node.type | ruleIcon }}
					</span>
				} @else {
					<ada-icon
						color="foreground"
						[icon]="node.type | ruleIcon"
					/>
				}
			</span>
			<div
				ada-color="foreground"
				class="ada-authoring-rule-display"
			>
				{{ node.display }}
			</div>
			<ada-icon
				ada-type="base"
				color="primary"
				horizontalAlignment="right"
				icon="faEllipsisH"
				style="cursor: pointer"
				tooltip="Filter Options"
				[adaMenuTrigger]="MainMenu"
				[adaMenuTriggerData]="node"
				[isDisabled]="isDisabled"
				[ngStyle]="{ height: UI.Spacing.SPACING_LARGE }"
			/>
		</div>
	</div>
	@if (node.isExpanded && node.children?.length) {
		<div class="node-children">
			@for (child of node.children; track child) {
				<ng-container *ngTemplateOutlet="NodeTemplate; context: { node: child }" />
			}
		</div>
	}
</ng-template>

<ada-menu
	#MainMenu
	[controller]="mainMenuController"
/>

<ada-overlay
	#SensorExpressionOverlay
	[beforeSubmit]="validateExpression.bind(this)"
	[title]="(overlayEditing ? 'Editing ' : 'Creating ') + 'Sensor Expression'"
	(sneakyClose)="cancelOverlay($event)"
	(submit)="submitRuleOverlay()"
>
	<ada-container
		*adaTemplateMarker
		[colCount]="4"
		[ngStyle]="{ padding: UI.Spacing.SPACING_LARGE }"
		[verticalSpacing]="'Medium'"
	>
		@if (expressionError$ | async; as _error) {
			<ada-alert
				type="error"
				[colSpan]="4"
				[isClosable]="false"
				[title]="_error"
			/>
		}
		<ada-expression-language-editor
			[colSpan]="4"
			[customCompletionItems]="availableProperties"
			[objectId]="(serverObject$ | async)?.objectId"
			[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
			[(expression)]="overlayUserInput"
		/>
	</ada-container>
</ada-overlay>
<ada-overlay
	#ReferenceOverlay
	id="ReferenceOverlay"
	[title]="(overlayEditing ? 'Editing ' : 'Selecting ') + 'Reference'"
	(sneakyClose)="cancelOverlay($event)"
	(submit)="submitRuleOverlay()"
>
	<ada-browser
		#ReferenceBrowser
		*adaTemplateMarker
		id="ReferenceBrowser"
		[allowMultiple]="false"
		[checkboxesEnabled]="true"
		[height]="'100%'"
		[javaClassName]="authoringRuleClass"
		[queryConfiguration]="standaloneQueryConfig | json"
		[selectionContext]="true"
		[width]="'100%'"
		(selectedNodeChange)="selectReference($event)"
	/>
</ada-overlay>
